// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FileList_file_graphql = require("../../../__generated__/FileList_file_graphql.bs.js");
let FileList_files_graphql = require("../../../__generated__/FileList_files_graphql.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");

let convertFragment = FileList_file_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, FileList_file_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(FileList_file_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, FileList_file_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(FileList_file_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function FileList$File(props) {
  let file = RescriptRelay_Fragment.useFragment(FileList_file_graphql.node, convertFragment, props.file);
  let match = file.contentType;
  let tmp;
  switch (match) {
    case "application/pdf" :
      tmp = "file-pdf";
      break;
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document" :
      tmp = "file-doc";
      break;
    default:
      tmp = "file";
  }
  return JsxRuntime.jsxs("a", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(IconV5.make, {
          icon: tmp,
          size: 48,
          className: "text-gray-400 group-hover:text-blue-300"
        })
      }),
      JsxRuntime.jsx("div", {
        children: file.fileName,
        className: "font-medium text-gray-700 text-center line-clamp-2 overflow-hidden break-all"
      })
    ],
    className: "border rounded-lg py-6 px-2 flex flex-col items-center gap-4 group\n      hover:border-blue-300 group w-40\n      ",
    href: file.url,
    target: "_blank"
  });
}

let File = {
  Fragment: Fragment,
  make: FileList$File
};

let convertFragment$1 = FileList_files_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, FileList_files_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(FileList_files_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, FileList_files_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(FileList_files_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function FileList(props) {
  let __showTitle = props.showTitle;
  let showTitle = __showTitle !== undefined ? __showTitle : true;
  let files = RescriptRelay_Fragment.useFragment(FileList_files_graphql.node, convertFragment$1, props.files);
  return JsxRuntime.jsxs("div", {
    children: [
      showTitle ? JsxRuntime.jsx("h2", {
          children: "Files",
          className: "text-2xl font-medium text-gray-800"
        }) : null,
      JsxRuntime.jsx("div", {
        children: files.map(file => JsxRuntime.jsx(FileList$File, {
          file: file.fragmentRefs
        })),
        className: "flex gap-8 flex-wrap"
      })
    ],
    className: "flex flex-col gap-4"
  });
}

let make = FileList;

exports.File = File;
exports.Fragment = Fragment$1;
exports.make = make;
/* IconV5 Not a pure module */
